module.exports = __webpack_public_path__ + "static/media/gryphon_artisan_series_s.1984e48a.jpg";